<template>
  <common-dialog ref="dialog" :title="title" width="330px" :in-dialog="inDialog">
    <div>
      <el-form ref="form" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-table border :data="tableData" size="small">
              <el-table-column type="index" label="考试次数" width="90" align="center" />
              <el-table-column prop="ExamRatio" label="成绩占比/%" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.ExamRatio" type="number" size="mini"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align:right;margin-top:10px;">
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="toClose">关 闭</el-button>
    </div>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
import api from "@/api/achieve/params/entry";

export default {
  components: { commonDialog },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "入口考试占比设置",
    },
  },
  data() {
    return {
      api,
      data: {},
      tableData: [],
    }
  },
  methods: {
    setData(ExamNumber) {
      this.tableData = [];
      this.api.list({ ExamNumber }).then(res => {
        if(res.Code == 0) {
          if(res.Data.length > 0) {
            let ExamRatio = res.Data[0].ExamRatio;
            let arr = ExamRatio.split("%")
            let result = []
            arr.forEach((e,index) => {
              if(index < arr.length-1) {
                result.push(e.split(": ")[1])
              }
            })
            for (let i = 0; i < ExamNumber; i++) {
              this.tableData.push({
                ExamRatio: result[i]
              })
            }
          } else if(ExamNumber==1) {
            this.tableData = [{ ExamRatio: 100 }]
          } else {
            for (let i = 0; i < ExamNumber; i++) {
              this.tableData.push({
                ExamRatio: 0
              })
            }
          }
        }
      })
    },
    confirm() {
      let td = this.tableData;
      let total = 0;
      for (let i = 0; i < td.length; i++) {
        if(!(td[i].ExamRatio>0)) {
          this.$message.error("成绩占比须大于0");
          return;
        }
        total += Number(td[i].ExamRatio);
      }
      if(total != 100) {
        this.$message.error("成绩占比总和须等于100");
        return;
      }
      this.$emit("confirm",this.tableData);
      td = [];
      this.close();
    },
    toClose() {
      this.tableData = [];
      this.close();
    }
  },
};
</script>